import { useCallback } from "react";
import { useSleepActivity, SleepActivityState } from "./SleepActivityContext";
import { transformSleepActivityStateToRequest } from "./transformSleepActivityStateToRequest";
import { useQueuedPatientUpdate } from "@louise/patients/sync/usePatientSync";

export function useSubmitSleepActivity() {
  const { state } = useSleepActivity();
  const { mutateAsync, isPending } = useQueuedPatientUpdate();

  const submit = useCallback(
    async (overrideState?: SleepActivityState) => {
      const payload = transformSleepActivityStateToRequest(
        overrideState ?? state,
      );
      if (Object.keys(payload).length === 0) return;
      await mutateAsync(payload);
    },
    [state, mutateAsync],
  );

  return { submit, isPending };
}
